import React from 'react';
import SphereMp4 from './video/sphere-small.mp4';
import SphereWebm from './video/sphere-small.webm';
export const SphereLoader = _ref => {
  let {
    className,
    size
  } = _ref;
  return /*#__PURE__*/React.createElement("video", {
    width: size,
    height: size,
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    className: className
  }, /*#__PURE__*/React.createElement("source", {
    src: SphereMp4,
    type: "video/quicktime"
  }), /*#__PURE__*/React.createElement("source", {
    src: SphereWebm,
    type: "video/webm"
  }));
};
//# sourceMappingURL=SphereLoader.js.map